'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('abstract-leveldown'),
    AbstractChainedBatch = _require.AbstractChainedBatch;

var kOperations = Symbol('operations');

module.exports = /*#__PURE__*/function (_AbstractChainedBatch) {
  _inherits(DeferredChainedBatch, _AbstractChainedBatch);

  var _super = _createSuper(DeferredChainedBatch);

  function DeferredChainedBatch(db) {
    var _this;

    _classCallCheck(this, DeferredChainedBatch);

    _this = _super.call(this, db);
    _this[kOperations] = [];
    return _this;
  }

  _createClass(DeferredChainedBatch, [{
    key: "_put",
    value: function _put(key, value, options) {
      this[kOperations].push(_objectSpread(_objectSpread({}, options), {}, {
        type: 'put',
        key: key,
        value: value
      }));
    }
  }, {
    key: "_del",
    value: function _del(key, options) {
      this[kOperations].push(_objectSpread(_objectSpread({}, options), {}, {
        type: 'del',
        key: key
      }));
    }
  }, {
    key: "_clear",
    value: function _clear() {
      this[kOperations] = [];
    }
  }, {
    key: "_write",
    value: function _write(options, callback) {
      // AbstractChainedBatch would call _batch(), we call batch()
      this.db.batch(this[kOperations], options, callback);
    }
  }]);

  return DeferredChainedBatch;
}(AbstractChainedBatch);